export function formatMissingRequiredFieldsMessage(fields = []) {
  const uniqueFields = Array.from(
    new Set(
      (Array.isArray(fields) ? fields : [])
        .map((value) => String(value || "").trim())
        .filter(Boolean)
    )
  );

  if (!uniqueFields.length) {
    return "";
  }

  if (uniqueFields.length === 1) {
    return `Please complete the required field: ${uniqueFields[0]}.`;
  }

  if (uniqueFields.length === 2) {
    return `Please complete the required fields: ${uniqueFields[0]} and ${uniqueFields[1]}.`;
  }

  return `Please complete the required fields: ${uniqueFields
    .slice(0, -1)
    .join(", ")}, and ${uniqueFields.at(-1)}.`;
}
